/* MrMobile lightweight wishlist — localStorage based, no app required. */
(function () {
  var KEY = 'mr_wishlist';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(l) { localStorage.setItem(KEY, JSON.stringify(l)); }
  function has(h) { return get().some(function (x) { return x.handle === h; }); }
  function toggle(item) {
    var l = get();
    var i = l.findIndex(function (x) { return x.handle === item.handle; });
    if (i > -1) { l.splice(i, 1); } else { l.unshift(item); }
    save(l); updateCount(); renderPage();
    return i === -1; // true = added
  }
  function remove(handle) {
    save(get().filter(function (x) { return x.handle !== handle; }));
    updateCount(); renderPage();
    document.querySelectorAll('.mr-wish-btn[data-handle="' + handle + '"]').forEach(function (b) { b.classList.remove('is-active'); });
  }

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21S3.5 15.4 3.5 9.6C3.5 6.5 6 4 9 4c1.5 0 2.5.7 3 1.5C12.5 4.7 13.5 4 15 4c3 0 5.5 2.5 5.5 5.6 0 5.8-8.5 11.4-8.5 11.4z"/></svg>';

  function updateCount() {
    var n = get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n === 0 ? 'none' : '';
    });
  }

  function cardItem(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    var img = card.querySelector('img');
    var priceEl = card.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--regular, .price__container .price-item, .price');
    var heading = card.querySelector('.card__heading');
    return {
      handle: m[1],
      url: (link.getAttribute('href') || '').split('?')[0],
      title: heading ? heading.textContent.trim() : m[1],
      image: img ? (img.currentSrc || img.src || '') : '',
      price: priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : ''
    };
  }

  function makeBtn(item) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mr-wish-btn';
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.setAttribute('data-handle', item.handle);
    btn.innerHTML = HEART;
    if (has(item.handle)) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var added = toggle(item);
      btn.classList.toggle('is-active', added);
      btn.classList.add('mr-wish-pop');
      setTimeout(function () { btn.classList.remove('mr-wish-pop'); }, 300);
    });
    return btn;
  }

  function injectCards(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.__mrWish) return;
      var item = cardItem(card);
      if (!item) return;
      // anchor the heart to the card-wrapper (outside the media stacking context)
      // so its z-index beats the full-card link overlay and clicks reach the heart
      card.__mrWish = true;
      card.classList.add('mr-wish-host');
      card.appendChild(makeBtn(item));
    });
  }

  function injectProductPage() {
    var form = document.querySelector('.product-form__buttons');
    if (!form || form.querySelector('.mr-wish-pdp')) return;
    var titleEl = document.querySelector('.product__title, .product__info-wrapper h1, h1');
    var img = document.querySelector('.product__media img, .product-media img, [id^="Slider-Gallery"] img');
    var priceEl = document.querySelector('.price__sale .price-item--sale, .price-item--regular, .price');
    var item = {
      handle: (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || location.pathname,
      url: location.pathname,
      title: titleEl ? titleEl.textContent.trim() : document.title,
      image: img ? (img.currentSrc || img.src || '') : '',
      price: priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : ''
    };
    if (!item.handle) return;
    var wrap = document.createElement('button');
    wrap.type = 'button';
    wrap.className = 'mr-wish-pdp';
    wrap.setAttribute('data-handle', item.handle);
    wrap.innerHTML = HEART + '<span>' + (has(item.handle) ? WORDS.saved : WORDS.add) + '</span>';
    if (has(item.handle)) wrap.classList.add('is-active');
    wrap.addEventListener('click', function () {
      var added = toggle(item);
      wrap.classList.toggle('is-active', added);
      wrap.querySelector('span').textContent = added ? WORDS.saved : WORDS.add;
    });
    form.appendChild(wrap);
  }

  var IS_AR = document.documentElement.getAttribute('dir') === 'rtl' ||
              (document.documentElement.getAttribute('lang') || '').indexOf('ar') === 0;
  var WORDS = IS_AR
    ? { add: 'أضف للمفضلة', saved: 'في المفضلة ✓', empty_t: 'قائمة مفضلتك فارغة', empty_s: 'اضغط على القلب ♡ على أي منتج لحفظه هنا.', shop: 'تصفّح المنتجات', view: 'عرض', remove: 'إزالة' }
    : { add: 'Add to wishlist', saved: 'In wishlist ✓', empty_t: 'Your wishlist is empty', empty_s: 'Tap the heart ♡ on any product to save it here.', shop: 'Browse products', view: 'View', remove: 'Remove' };

  function renderPage() {
    var grid = document.getElementById('mr-wishlist-grid');
    if (!grid) return;
    var items = get();
    var empty = document.getElementById('mr-wishlist-empty');
    if (!items.length) {
      grid.innerHTML = '';
      if (empty) {
        empty.hidden = false;
        empty.innerHTML = '<div class="mr-wishlist__empty"><svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M12 21S3.5 15.4 3.5 9.6C3.5 6.5 6 4 9 4c1.5 0 2.5.7 3 1.5C12.5 4.7 13.5 4 15 4c3 0 5.5 2.5 5.5 5.6 0 5.8-8.5 11.4-8.5 11.4z"/></svg>' +
          '<h3>' + WORDS.empty_t + '</h3><p>' + WORDS.empty_s + '</p><a class="button" href="/collections/all">' + WORDS.shop + '</a></div>';
      }
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(function (it) {
      return '<div class="mr-wishcard">' +
        '<button class="mr-wishcard__remove" data-remove="' + it.handle + '" aria-label="' + WORDS.remove + '">&times;</button>' +
        '<a class="mr-wishcard__media" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<a class="mr-wishcard__title" href="' + it.url + '">' + it.title + '</a>' +
        (it.price ? '<div class="mr-wishcard__price">' + it.price + '</div>' : '') +
        '<a class="button mr-wishcard__btn" href="' + it.url + '">' + WORDS.view + '</a>' +
        '</div>';
    }).join('');
    grid.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { remove(b.getAttribute('data-remove')); });
    });
  }

  function init() {
    injectCards();
    injectProductPage();
    updateCount();
    renderPage();
    // watch for dynamically added cards (sliders, quick add, predictive search)
    var mo = new MutationObserver(function (muts) {
      var doInject = false;
      muts.forEach(function (m) { if (m.addedNodes && m.addedNodes.length) doInject = true; });
      if (doInject) injectCards();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // sync across tabs
    window.addEventListener('storage', function (e) { if (e.key === KEY) { updateCount(); renderPage(); document.querySelectorAll('.mr-wish-btn').forEach(function (b) { b.classList.toggle('is-active', has(b.getAttribute('data-handle'))); }); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
